import type { ShellCartLine, ShellFailureKind, ShellOrderStatusStep, ShellStepId } from "./types.js";

export const DEMO_BANNER_TEXT =
  "INTERNAL BETA (1–3 testers) · staging only · not public · test orders only";

/** Unified staging strip — payment/NP never claimed live. */
export const STAGING_GUARDRAIL_BANNER =
  "STAGING · Cloudflare D1 · payment not live · Nova Poshta / TTN not live · no real payment instructions";

/** No real customer PII, phones, emails, or order IDs. */
export const SHELL_MOCK_CART: ShellCartLine[] = [
  {
    id: "demo-line-1",
    title: "Staging test product A",
    skuLabel: "SKU-STG-001",
    qty: 1,
    amountLabel: "— (test, not a sale)",
  },
  {
    id: "demo-line-2",
    title: "Staging test product B",
    skuLabel: "SKU-STG-002",
    qty: 2,
    amountLabel: "— (test, not a sale)",
  },
];

export const SHELL_MOCK_CONTACT = {
  fullName: "Internal Tester",
  phone: "+380 XX XXX XX XX",
  note: "Internal beta test — not a customer order",
};

export const SHELL_MOCK_DELIVERY = {
  methodLabel: "Nova Poshta warehouse (staging placeholder)",
  cityLabel: "Test city — no live NP API",
  warehouseLabel: "Test warehouse — TTN not live",
};

export const SHELL_MOCK_PAYMENT = {
  optionLabel: "Manual payment (staging) — provider not live",
  statusLabel: "Do not send real money unless ops explicitly approved a test",
};

export const SHELL_MOCK_TG50 = {
  codeInput: "TG50",
  statusLabel: "TG50 via D1 staging API (use D1 actions panel) — shell field is preview only",
};

export const SHELL_MOCK_DRAFT = {
  draftLabel: "STAGING-TEST-DRAFT",
  message: "Use D1 staging actions to create a real staging draft/order. Mock panel is preview only.",
};

export const SHELL_MOCK_TIMELINE: ShellOrderStatusStep[] = [
  { id: "draft", label: "Draft", state: "done", note: "Staging test path" },
  { id: "placed", label: "Placed", state: "current", note: "D1 staging ledger" },
  { id: "awaiting_payment", label: "Payment pending (manual)", state: "upcoming", note: "Not live provider" },
  { id: "paid", label: "Paid (manual confirm)", state: "upcoming", note: "Manager only" },
  { id: "packing", label: "NP / packing", state: "upcoming", note: "No live TTN" },
  { id: "shipped", label: "Shipped manual", state: "upcoming", note: "ttn_status created_later only" },
];

export const SHELL_STEP_ORDER: ShellStepId[] = [
  "cart_review",
  "contact",
  "delivery_method",
  "nova_poshta",
  "payment_option",
  "tg50",
  "order_review",
  "order_draft",
  "payment_pending",
  "order_status",
  "failure_gallery",
];

export const SHELL_STEP_TITLES: Record<ShellStepId, string> = {
  cart_review: "Cart review",
  contact: "Contact",
  delivery_method: "Delivery method",
  nova_poshta: "Nova Poshta",
  payment_option: "Payment",
  tg50: "TG50 coupon",
  order_review: "Order review",
  order_draft: "Order draft",
  payment_pending: "Payment pending",
  order_status: "Order status",
  failure_gallery: "Failure states",
};

export const SHELL_FAILURE_COPY: Record<
  ShellFailureKind,
  { title: string; body: string }
> = {
  supabase_unavailable: {
    title: "Supabase temporarily unavailable",
    body: "Service is temporarily unavailable. Checkout is frozen until platform recovery.",
  },
  checkout_unavailable: {
    title: "Checkout unavailable",
    body: "Checkout cannot run without live cart and draft endpoints. UI shell only.",
  },
  payment_unavailable: {
    title: "Payment unavailable",
    body: "Payment providers are not connected in this shell. Do not claim payment ready.",
  },
  nova_poshta_unavailable: {
    title: "Nova Poshta unavailable",
    body: "City/warehouse lookup is a placeholder. No Nova Poshta API calls.",
  },
  stock_verification_required: {
    title: "Stock verification required",
    body: "Live stock must be verified on the server before placing an order.",
  },
  manager_confirmation_required: {
    title: "Manager confirmation required",
    body: "Some steps need manager confirmation. Not automated in this shell.",
  },
};
